import React from "react";
import Iterator from "../../utils/Iterator";
import CartRow from "./CartRow";

function TableCart({ handleUpdateQuantity, handleRemoveItem, ...props }: any) {
  return (
    <div className="flex flex-col gap-3 md:gap-4">
      <Iterator
        data={props.data}
        render={(e: any, i: number) => (
          <div
            key={e?.id || i}
            className="opacity-0 animate-fadeInUp"
            style={{
              animationDelay: `${i * 50}ms`,
            }}
          >
            <CartRow
              element={e}
              handleUpdateQuantity={handleUpdateQuantity}
              handleRemoveItem={handleRemoveItem}
            />
          </div>
        )}
      />
    </div>
  );
}

export default TableCart;
